document.querySelector('.site-header__menu-toggle').addEventListener('click', function () {
    document.querySelector('body').classList.toggle('prevent-scroll');
    document.querySelector('.site-header__menu').classList.toggle('site-header__menu-open');
    document.querySelector('.site-header__menu-toggle').classList.toggle('site-header__menu-toggle-open');
});

document.addEventListener('DOMContentLoaded', function() {

    if(window.innerWidth < 992) {
        const megamenuLinkTrigger = document.querySelectorAll('.site-header__menu-item-has-children .site-header__menu-link');
        megamenuLinkTrigger.forEach(link => link.addEventListener('click',()=>{
            if (link.nextElementSibling.classList.contains('site-header__megamenu--open')) {
                link.nextElementSibling.classList.remove('site-header__megamenu--open');
            } else {
                removeActiveClassesMegaMenu();
                link.nextElementSibling.classList.add('site-header__megamenu--open');
            }
        }))
        function removeActiveClassesMegaMenu(){
            megamenuLinkTrigger.forEach(link => link.nextElementSibling.classList.remove('site-header__megamenu--open'))
        }
        const megamenuLinkInner = document.querySelectorAll('.site-header__megamenu-link .site-header__megamenu-link-arrow');
        megamenuLinkInner.forEach(link => link.addEventListener('click',()=>{
            if (link.parentElement.classList.contains('open')) {
                link.parentElement.classList.remove('open');
            } else {
                removeActiveClasses();
                link.parentElement.classList.add('open');
            }
        }))
        function removeActiveClasses(){
            megamenuLinkInner.forEach(link => link.parentElement.classList.remove('open'))
        }
    }

    document.querySelector('.js-site-header__icon-search').addEventListener('click', function() {
        document.querySelector('body').classList.add('prevent-scroll');
        document.querySelector('.js-search-block').classList.add('is-active');
        document.querySelector('.js-site-header__icon-search-close').classList.add('show');
        document.querySelector('.js-site-header__icon-search').classList.add('hide');
    
        setTimeout(function() {
            document.querySelector('.js-search-block__input-input').focus();
        }, 100);
    });
    document.body.addEventListener('mouseup', function(e) {
        e.preventDefault();
    
        const searchBlock = document.querySelector('.js-search-block');
        const searchBlockInner = document.querySelector('.js-search-block__inner');
    
        if (searchBlock.classList.contains('is-active') &&
            !searchBlockInner.contains(e.target) &&
            !searchBlockInner.contains(e.target)) {
                document.querySelector('body').classList.remove('prevent-scroll');
                document.querySelector('.js-search-block').classList.remove('is-active');
                document.querySelector('.js-site-header__icon-search-close').classList.remove('show');
                document.querySelector('.js-site-header__icon-search').classList.remove('hide');
        }
    });
});

document.addEventListener('scroll', function() {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const domHeader = document.querySelector('.site-header');

    if (scrollTop > 20) {
        domHeader.classList.add('is-sticky');
    } else {
        domHeader.classList.remove('is-sticky');
    }
});

function moveSiteHeaderUpper() {
    const siteHeaderUpper = document.querySelector('.site-header__upper');
    const siteHeaderMenu = document.querySelector('.site-header__menu');
    const siteHeader = document.querySelector('.site-header');
  
    if (window.innerWidth <= 991) {
      // If window width is 991 or below, append site-header__upper to site-header__menu
      if (!siteHeaderMenu.contains(siteHeaderUpper)) {
        siteHeaderMenu.appendChild(siteHeaderUpper);
        siteHeaderUpper.style.display = 'block';
      }
    } else {
      // If window width is above 991, move site-header__upper as the first child inside site-header
      if (siteHeader.firstChild !== siteHeaderUpper) {
        siteHeader.insertBefore(siteHeaderUpper, siteHeader.firstChild);
        siteHeaderUpper.style.display = 'block';
      }
    }
}
  
if (window.innerWidth <= 991) {
    document.addEventListener('DOMContentLoaded', function() {
        const siteHeaderUpper = document.querySelector('.site-header__upper');
        siteHeaderUpper.style.display = 'none';
    });
}
  
// Move site-header__upper on window resize
window.addEventListener('resize', moveSiteHeaderUpper);
  
// Move site-header__upper when DOM is fully loaded
window.onload = function() {
    moveSiteHeaderUpper();
};

if (window.innerWidth > 991) {
    document.addEventListener("DOMContentLoaded", function() {
        const links = document.querySelectorAll('.js-site-header__megamenu-link') || null;
        const images = document.querySelectorAll('.site-header__megamenu-links-image img') || null;
        
        if (links.length !== images.length) {
            console.error('The number of links does not match the number of images.');
            return;
        }

        // Adding condition to check if elements exist, to prevent JS error
        if (links != null && links.length > 0 && images != null && images.length > 0) {
          // Initially, make the first image visible
          images[0].classList.add('is-visible');
  
          // Simulate hover for the first link
          links[0].classList.add('is-hovered');
  
          links.forEach((link, index) => {
              link.addEventListener('mouseover', function() {
                  // Remove the 'is-hovered' class from all links
                  links.forEach(link => link.classList.remove('is-hovered'));
                  // Add 'is-hovered' class to the hovered link
                  link.classList.add('is-hovered');
                  // Hide all images
                  images.forEach(img => img.classList.remove('is-visible'));
                  // Show the corresponding image
                  images[index].classList.add('is-visible');
              });
          });
        }
    });
}